import { Loader2 } from "lucide-react";
import { useState } from "react";
import {
  useCopyDrawingToolData,
  useGetProductSalesUnitsNotSavedDrawing
} from "../../api/drawingTool";
import { DropDown } from "../../components";
import { Button } from "../../components/ui/common/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "../../components/ui/common/dialog";
import { MappingSourceType } from "../../config/enums/MappingSourceType.enum";
import {
  mappingDialogBodyClass,
  mappingDialogContentClass,
  mappingDialogDropdownClass,
  mappingDialogFooterClass,
  mappingDialogHeaderClass,
  mappingDialogLoadingOverlayClass
} from "./mappingModalStyles";

const CopyMappingModal = ({
  viewModal = false,
  closeModal = () => {},
  drawingId,
  onSuccessCopy
}: any) => {
  const [searchKey, setSearchKey] = useState("");
  const [toCopyData, setToCopyData] = useState<any>();

  const { data: salesUnits, isLoading: isSalesUnitsLoading } =
    useGetProductSalesUnitsNotSavedDrawing({
      mappingType: MappingSourceType.product,
      searchKey
    });

  const salesUnitsValues: DropdownOption[] = (salesUnits || []).map(
    ({ productName, salesUnitName, salesUnitId, productId }) => ({
      key: salesUnitId,
      text: `${productName} - ${salesUnitName}`,
      value: salesUnitId,
      product: productId
    })
  );

  const { mutate: copyDrawing, isLoading: isLoadingCopyDrawing } = useCopyDrawingToolData(
    MappingSourceType.product
  );

  const pasteDrawing = () => {
    copyDrawing(
      {
        drawingId,
        ownerId: toCopyData.product,
        sourceId: toCopyData.value
      },
      {
        onSuccess: () => {
          closeModal();
          onSuccessCopy(toCopyData.value);
        },
        onError: () => {
          closeModal();
        }
      }
    );
  };

  return (
    <Dialog open onOpenChange={open => !open && closeModal()}>
      <DialogContent
        className={mappingDialogContentClass}
        onOpenAutoFocus={event => event.preventDefault()}
      >
        <DialogHeader className={mappingDialogHeaderClass}>
          <DialogTitle>Copy Mapping!</DialogTitle>
        </DialogHeader>

        <div className={`${mappingDialogBodyClass} ${mappingDialogDropdownClass}`}>
          {isLoadingCopyDrawing ? (
            <div className={mappingDialogLoadingOverlayClass}>
              <Loader2 className="tw-h-6 tw-w-6 tw-animate-spin tw-text-primary" />
            </div>
          ) : null}

          <DropDown
            currentData={salesUnitsValues}
            defaultValue={toCopyData?.value}
            handleChangeState={(e: any, data: any) => {
              const values = salesUnitsValues.find(ps => ps.key === data.value);
              setToCopyData(values);
            }}
            onSearchChange={(e: any, data: any) => {
              setSearchKey(data.searchQuery);
            }}
            loading={isSalesUnitsLoading}
            search={options => options}
            showNoResults={false}
            minSearchLength={1}
            defaultOpen={false}
            placeholder="Search product..."
          />
          <p className="tw-m-0 tw-text-sm tw-text-muted-foreground">
            Please select the product or create the product if product is not available from the
            dropdown.
          </p>
        </div>

        <DialogFooter className={mappingDialogFooterClass}>
          <Button
            type="button"
            variant="outline"
            disabled={isLoadingCopyDrawing}
            onClick={() => closeModal()}
          >
            Cancel
          </Button>
          <Button
            type="button"
            disabled={isLoadingCopyDrawing || !toCopyData}
            onClick={() => pasteDrawing()}
          >
            Copy
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CopyMappingModal;
